import React from "react";
import { Link } from "react-router-dom";
import {
  Cpu, Network, Cloud, ShieldCheck, Phone, Globe, ArrowRight, Check
} from "lucide-react";
import { siteData } from "../mock";

const iconMap = { Cpu, Network, Cloud, ShieldCheck, Phone, Globe };

const extendedList = [
  "Computer support", "Server support", "Networking", "Infrastructure",
  "Internet phones (VoIP)", "Broadband", "Network support", "Microsoft 365",
  "Cloud technologies", "Phone line rental", "Website hosting",
  "Domain name registration", "Email systems", "Data backup",
  "Disaster recovery", "Wireless solutions", "SCCM", "Azure",
];

const Service = () => {
  return (
    <div className="bg-[#05070d]">
      <section className="relative pt-36 pb-16 bg-gradient-to-br from-[#05070d] via-[#0b1220] to-[#05070d]">
        <div className="absolute inset-0 dark-grid" />
        <div className="relative max-w-7xl mx-auto px-5 md:px-8">
          <span className="text-xs font-semibold tracking-[0.25em] text-blue-400">SERVICES</span>
          <h1 className="mt-3 text-4xl md:text-5xl font-bold tracking-tight text-white max-w-3xl">
            Everything your business needs from an IT partner — under one roof.
          </h1>
          <p className="mt-5 text-white/70 max-w-2xl leading-relaxed">
            {siteData.services.intro}
          </p>
        </div>
      </section>

      <section className="py-20 bg-[#05070d]">
        <div className="max-w-7xl mx-auto px-5 md:px-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {siteData.services.items.map((svc, i) => {
            const Icon = iconMap[svc.icon] || Cpu;
            return (
              <div key={i} className="p-6 rounded-xl border border-white/10 bg-white/[0.03] hover:border-blue-500/60 hover:bg-white/[0.06] transition-all">
                <div className="w-11 h-11 rounded-lg bg-blue-500/10 text-blue-300 flex items-center justify-center mb-4">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="text-lg font-semibold text-white">{svc.title}</h3>
                <p className="mt-2 text-sm text-white/65 leading-relaxed">{svc.desc}</p>
              </div>
            );
          })}
        </div>
      </section>

      <section className="py-20 bg-[#080b14]">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <span className="accent-bar mb-4" />
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white">Full capability list</h2>
          <p className="mt-4 text-white/65 max-w-2xl">If you don’t see it here, ask us — we probably still do it.</p>
          <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-3">
            {extendedList.map((it, i) => (
              <li key={i} className="flex items-start gap-3 text-white/85">
                <span className="mt-0.5 w-5 h-5 rounded-full bg-blue-500/20 flex items-center justify-center flex-shrink-0">
                  <Check className="w-3.5 h-3.5 text-blue-300" strokeWidth={3} />
                </span>
                <span>{it}</span>
              </li>
            ))}
          </ul>
          <div className="mt-10">
            <Link to="/contact" className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-blue-600 text-white font-semibold hover:bg-blue-500 transition-colors">
              Discuss your project <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Service;
